import React from "react"

import { withAuthenticationRequired } from "@auth0/auth0-react"
import { useIntl } from "react-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"
import WalletNavigation from "../components/wallet_navigation"
import WalletSend from "../components/wallet_send"

const WalletSendPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Send" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <WalletNavigation location={location} />
      <WalletSend />
    </Layout>
  )
}

export default withAuthenticationRequired(WalletSendPage)
